/**
 * The following image file formats can be uploaded by the user
 */
export const acceptedFileTypes = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/tiff',
];

export const acceptedExcelTypes = [
  'numbers',
  'spreadsheetml',
  'xla',
  'xls',
  'xlt',
  'xlw',
  'xlm',
  'xlr',
  'xlsx',
  'xlsm',
  'xlsb',
  'xltx',
  'xltm',
  'xlam',
  'xlsm',
];
